import { defineMessages } from '@sm/intl';
import { Packages } from '~shared/constants/pricing';

const FORMS = 'GROW-2529';
const DESC_MESSAGE = '[Type: String][Vis.: high] - form features summary - A string in pricing experiment GROW-2529';

const experimentSummaryCopy = defineMessages({
  // corresponding term in existing copy not found
  grow_2529_question_types: {
    id: 'Pricing.experimentSummaryCopy.AllQuestionTypes',
    defaultMessage: 'All question types',
    desc: {
      id: 'Pricing.experimentSummaryCopy.AllQuestionTypesDesc',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_forms_question_types: {
    id: 'Pricing.experimentSummaryCopy.FormQuestionTypes',
    defaultMessage: 'Form question types',
    desc: {
      id: 'Pricing.experimentSummaryCopy.FormQuestionTypesDesc',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_unlimited_forms: {
    id: 'Pricing.experimentSummaryCopy.UnlimitedForms',
    defaultMessage: 'Unlimited number of forms',
    desc: {
      id: 'Pricing.experimentSummaryCopy.UnlimitedFormsDesc',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_website_embed: {
    id: 'Pricing.experimentSummaryCopy.WebsiteEmbed',
    defaultMessage: 'Website embed',
    desc: {
      id: 'Pricing.experimentSummaryCopy.WebsiteEmbedDesc',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_zapier_integrations: {
    id: 'Pricing.experimentSummaryCopy.ZapierIntegrations',
    defaultMessage: '5000+ integrations with Zapier',
    desc: {
      id: 'Pricing.experimentSummaryCopy.ZapierIntegrations',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_file_upload: {
    id: 'Pricing.experimentSummaryCopy.FileUpload',
    defaultMessage: 'File upload',
    desc: {
      id: 'Pricing.experimentSummaryCopy.FileUploadDesc',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_payment_qt: {
    id: 'Pricing.experimentSummaryCopy.AcceptPayments',
    defaultMessage: 'Accept payments',
    desc: {
      id: 'Pricing.experimentSummaryCopy.AcceptPaymentsDesc',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_quizzes_pro: {
    id: 'Pricing.experimentSummaryCopy.QuizzesPro',
    defaultMessage: 'Quizzes with custom feedback',
    desc: {
      id: 'Pricing.experimentSummaryCopy.QuizzesPro',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_survey_create_limit: {
    id: 'Pricing.experimentSummaryCopy.SurveyCreateLimit',
    defaultMessage: 'Unlimited number of surveys and forms',
    desc: {
      id: 'Pricing.experimentSummaryCopy.SurveyCreateLimit',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_analysis_filter: {
    id: 'Pricing.experimentSummaryCopy.AnalysisFilter',
    defaultMessage: 'Unlimited analysis filter',
    desc: {
      id: 'Pricing.experimentSummaryCopy.AnalysisFilterDesc',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_forms_analysis_filter: {
    id: 'Pricing.experimentSummaryCopy.FormsAnalysisFilter',
    defaultMessage: '1 analysis filter',
    desc: {
      id: 'Pricing.experimentSummaryCopy.FormsAnalysisFilter',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_unlimited_questions: {
    id: 'Pricing.experimentSummaryCopy.FieldsPerForm',
    defaultMessage: 'Unlimited questions per survey/Unlimited fields per form',
    desc: {
      id: 'Pricing.experimentSummaryCopy.FieldsPerForm',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_forms_unlimited_questions: {
    id: 'Pricing.experimentSummaryCopy.FormsFieldsPerForm',
    defaultMessage: 'Unlimited fields per form',
    desc: {
      id: 'Pricing.experimentSummaryCopy.FormsFieldsPerForm',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_survey_branding: {
    id: 'Pricing.experimentSummaryCopy.SummarySurveyBranding',
    defaultMessage: 'Custom logo, colors, and survey/form URL',
    desc: {
      id: 'Pricing.experimentSummaryCopy.SummarySurveyBranding',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  // treatment 2
  grow_2529_data_exports: {
    id: 'Pricing.experimentSummaryCopy.SummaryDataExports',
    defaultMessage: 'Data exports (CSV, PDF, PPT, XLS)',
    desc: {
      id: 'Pricing.experimentSummaryCopy.SummaryDataExports',
      message: `${DESC_MESSAGE} - SummaryDataExports`,
      project: FORMS,
    },
  },
  grow_2529_statistical_significance: {
    id: 'Pricing.experimentSummaryCopy.SummaryStatisticalSignificance',
    defaultMessage: 'A/B testing & Statistical significance',
    desc: {
      id: 'Pricing.experimentSummaryCopy.SummaryStatisticalSignificance',
      message: `${DESC_MESSAGE} - SummaryStatisticalSignificance`,
      project: FORMS,
    },
  },
  grow_2529_multilingual: {
    id: 'Pricing.experimentSummaryCopy.MultilingualSurveysAndForms',
    defaultMessage: 'Multilingual surveys and forms',
    desc: {
      id: 'Pricing.experimentSummaryCopy.MultilingualSurveysAndForms',
      message: `${DESC_MESSAGE} - MultilingualSurveysAndForms`,
      project: FORMS,
    },
  },
  grow_2529_survey_quiz: {
    id: 'Pricing.experimentSummaryCopy.SurveyQuizQuestionTypes',
    defaultMessage: 'Survey & Quiz question types',
    desc: {
      id: 'Pricing.experimentSummaryCopy.SurveyQuizQuestionTypes',
      message: `${DESC_MESSAGE} - SurveyQuizQuestionTypes`,
      project: FORMS,
    },
  },
  grow_2529_unlimited_analysis_filters: {
    id: 'Pricing.experimentSummaryCopy.UnlimitedAnalysisFilters',
    defaultMessage: 'Unlimited analysis filters',
    desc: {
      id: 'Pricing.experimentSummaryCopy.UnlimitedAnalysisFilters',
      message: `${DESC_MESSAGE} - UnlimitedAnalysisFilters`,
      project: FORMS,
    },
  },
  [`everything_in_${Packages.FormsAnnual}`]: {
    id: 'Pricing.experimentSummaryCopy.FormsAnnualTagLine',
    defaultMessage: `What's included`,
    desc: {
      id: 'Pricing.experimentSummaryCopy.FormsAnnualTagLine',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  [`everything_in_${Packages.FormsMonthly}`]: {
    id: 'Pricing.experimentSummaryCopy.FormsMonthlyTagLine',
    defaultMessage: `What's included`,
    desc: {
      id: 'Pricing.experimentSummaryCopy.FormsMonthlyTagLine',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  [`everything_in_${Packages.AdvantageAnnual}`]: {
    id: 'Pricing.experimentSummaryCopy.AdvantageAnnualTagLine',
    defaultMessage: `Everything in Starter, plus`,
    desc: {
      id: 'Pricing.experimentSummaryCopy.AdvantageAnnualTagLine',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  [`everything_in_${Packages.StarterAnnual}`]: {
    id: 'Pricing.experimentSummaryCopy.StarterAnnualTagLine',
    defaultMessage: `Everything in Forms, plus`,
    desc: {
      id: 'Pricing.experimentSummaryCopy.StarterAnnualTagLine',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  [`everything_in_${Packages.PremierAnnual}`]: {
    id: 'Pricing.experimentSummaryCopy.PremierAnnualTagLine',
    defaultMessage: `Everything in Advantage, plus`,
    desc: {
      id: 'Pricing.experimentSummaryCopy.PremierAnnualTagLine',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_phone_support: {
    id: 'Pricing.experimentSummaryCopy.PhoneSupport',
    defaultMessage: 'Phone support',
    desc: {
      id: 'Pricing.experimentSummaryCopy.PhoneSupport',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_analyze_sentiment_enabled: {
    id: 'Pricing.experimentSummaryCopy.SummaryAnalyzeSentimentEnabled',
    defaultMessage: 'Sentiment analysis',
    desc: {
      id: 'Pricing.experimentSummaryCopy.SummaryAnalyzeSentimentEnabled',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_survey_branding_t2: {
    id: 'Pricing.experimentSummaryCopy.SummarySurveyBrandingT2',
    defaultMessage: 'Custom logo, colors, and URL',
    desc: {
      id: 'Pricing.experimentSummaryCopy.SummarySurveyBrandingT2',
      message: DESC_MESSAGE,
      project: FORMS,
    },
  },
  grow_2529_analyze_export_spss_enabled_t2: {
    id: 'Pricing.experimentSummaryCopy.SummaryAnalyzeExportSpssEnabled',
    defaultMessage: 'SPSS data exports',
    desc: {
      id: 'Pricing.experimentSummaryCopy.SummaryAnalyzeExportSpssEnabled',
      message: `${DESC_MESSAGE} - SummaryAnalyzeExportSpssEnabled`,
      project: FORMS,
    },
  },
  grow_2529_skip_logic: {
    id: 'Pricing.experimentSummaryCopy.SkipLogic',
    defaultMessage: 'Skip logic only',
    desc: {
      id: 'Pricing.experimentSummaryCopy.SkipLogic',
      message: `${DESC_MESSAGE} - SkipLogic`,
      project: FORMS,
    },
  },
  grow_2529_collector_white_label_enabled: {
    id: 'Pricing.experimentSummaryCopy.WhiteLabel',
    defaultMessage: 'White label surveys',
    desc: {
      id: 'Pricing.experimentSummaryCopy.WhiteLabel',
      message: `${DESC_MESSAGE} - WhiteLabel`,
      project: FORMS,
    },
  },
  grow_2529_text_analysis: {
    id: 'Pricing.experimentSummaryCopy.TextAnalysis',
    defaultMessage: 'Text analysis',
    desc: {
      id: 'Pricing.experimentSummaryCopy.TextAnalysis',
      message: `${DESC_MESSAGE} - TextAnalysis`,
      project: FORMS,
    },
  },
});

export default experimentSummaryCopy;
